import { Repository } from "src/firebase/firestore/repository";
import { ScheduledPost } from "../types/scheduled-posts.entity";

class ScheduledPostRepository extends Repository<ScheduledPost> {
  constructor() {
    super("scheduled_posts");
  }
}

export const scheduledPostRepository = new ScheduledPostRepository();
